import { Controller } from 'stimulus';
import { openModal } from '@/js/modules/turbo-modal';

export default class extends Controller {
  static values = {
    paymentUrl: String,
    paymentStatuses: { type: Array, default: ['paid', 'partial', 'partially_paid'] },
  };

  statusChanged(event) {
    const status = event.target.value;
    if (!this.paymentStatusesValue.includes(status)) {
      return;
    }

    openModal(this.#paymentUrlFor(status))
      .then((paymentModal) => {
        if (paymentModal) {
          this.#closeStatusModal();
          // Closing the dialog hands focus back to its opener, which sits behind the payment modal.
          paymentModal.querySelector('form select, form input:not([type="hidden"])')?.focus();
        }
      })
      .catch(console.error);
  }

  #paymentUrlFor(status) {
    const url = new URL(this.paymentUrlValue, window.location.href);
    url.searchParams.set('status', status);

    return `${url.pathname}${url.search}`;
  }

  #closeStatusModal() {
    this.element.closest('dialog').close();
  }
}
